// import { NameModel } from 'src/app/shared/models';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ISearchResponse, ITypeaheadOption } from '../component/typeahead/typeahead.service';

export const CodeDescriptionSeperator = "~";
export const FALSEVALUE = "N";


export function passwordMatchValidator(passwordField: string, confirmPasswordField: string): ValidatorFn {
  return (form: AbstractControl): ValidationErrors | null => {
    const password = form.get(passwordField)?.value;
    const confirmPassword = form.get(confirmPasswordField)?.value;

    if (password !== confirmPassword) {
      form.get(confirmPasswordField)?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      // Important: clear error if they now match
      const errors = form.get(confirmPasswordField)?.errors;
      if (errors && errors['passwordMismatch']) {
        delete errors['passwordMismatch'];
        if (Object.keys(errors).length === 0) {
          form.get(confirmPasswordField)?.setErrors(null);
        } else {
          form.get(confirmPasswordField)?.setErrors(errors);
        }
      }
    }

    return null;
  };
}

export function requiredValueValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const val = control.value as ITypeaheadOption;

    if (!val || typeof val !== 'object' || !val.Value || val.Value.trim() === '') {
      return { valueRequired: true };
    }

    return null;
  };
}

export function FormatCodeDescriptionToDisplay(code: string, description: string): string {
  return code + (description != undefined && description.trim().length > 0 ? '-' + description : '');
}

export function getSplittedValue(value: string) {
  return (value.includes('¯')) ? value.split('¯') : '';
}

export function getSplittedValueWithTilde(value: string) {
  return (value) ? value.split(CodeDescriptionSeperator) : '';
}

export function FormatDescriptionToDisplay(code: string, description: string,) {
  return (description != undefined && description.trim().length > 0 ? description : code);
}

export function FormateCodeDescriptionUsingTilde(code: string, description: string) {
  let returnValue = '';
  if (code)
    returnValue = code.trim();
  if (description)
    returnValue = returnValue + ((returnValue) ? (CodeDescriptionSeperator + description.trim()) : description.trim());
  return returnValue;
}

export function RetriveDescription(codeColumnName: string, descriptionCoumnName: string) {
  return "CASE WHEN LEN(LTRIM(ISNULL(" + descriptionCoumnName + "#SPACE(0)))) > 0 THEN ISNULL(" + descriptionCoumnName + "#SPACE(0)) ELSE ISNULL(" + codeColumnName + "#SPACE(0)) END";
}

export function RetriveCodeDescriptionUsingTilde(codeColumnName: string, descriptionCoumnName: string) {
  return "ISNULL(" + codeColumnName + "#SPACE(0)) + CASE WHEN LEN(LTRIM(ISNULL(" + descriptionCoumnName + "#SPACE(0)))) > 0 THEN '" + CodeDescriptionSeperator + "' + ISNULL(" + descriptionCoumnName + "#SPACE(0)) ELSE SPACE(0) END";
}

export function commonFormatter(item: ISearchResponse) {
  const strSplt = getSplittedValue(item.Second)
  const typeahead: ITypeaheadOption = {
    DisplayText: strSplt[1] || strSplt[0],
    Value: strSplt[0],
    DisplayTextInSuggestion: item.First
  }

  return typeahead;
}

export function commonTildFormatter(item: ISearchResponse) {
  const strSplt = getSplittedValueWithTilde(item.Second)
  const typeahead: ITypeaheadOption = {
    DisplayText: FormateCodeDescriptionUsingTilde(strSplt[0], strSplt[1]),
    Value: strSplt[0],
    DisplayTextInSuggestion: item.First
  }

  return typeahead;
}

export function stringToBoolean(string: string | boolean) {
  if (string == true)
    return true;
  if (string == false)
    return false;

  switch (string) {
    case "true": case "True": case "yes": case "Y": return true;
    case "false": case "False": case "no": case "N": case null: return false;
    default: return false;
  }
}

export function normalizeHtml(value: string) {
  return value.replace(/&amp;amp;/g, "&amp;")
    .replace(/&amp;#39;/g, "&#39;")
    .replace(/&amp;quot;/g, "&quot;");
}

export function encodeHtml(value: string) {
  return value.replace(/&/g, "&amp;") // Encode '&' as "&amp;"
    .replace(/'/g, "&#39;") // Encode single quote as "&#39;"
    .replace(/"/g, "&quot;"); // Encode double quote as "&quot;"
}

export function convertPxToRem(px: number) {
  return px / parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function stripHtml(html: string): string {
  if (!html) return '';

  const blocks = /(div|p|li|tr|section|article|header|footer|h[1-6])/i;
  let normalizedHtml = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(new RegExp(`</${blocks.source}>`, 'gi'), '\n')
    .replace(new RegExp(`<${blocks.source}(\\s[^>]*)?>`, 'gi'), '\n');

  normalizedHtml = normalizedHtml.replace(/<[^>]+>/g, '');

  const div = document.createElement('div');
  div.innerHTML = normalizedHtml;
  normalizedHtml = div.textContent || div.innerText || '';

  return normalizedHtml.replace(/\n{2,}/g, '\n').trim();
}

export function convertDateToFormattedString(date: Date | null): string | null {
  if (!date) return null;

  const days = date.getDate();
  const parsedDays = days < 10 ? `0${days}` : `${days}`;
  const month = date.getMonth();
  const parsedMonth = month < 9 ? `0${month + 1}` : `${month + 1}`;
  const year = date.getFullYear();
  return `${parsedMonth}-${parsedDays}-${year}`;
}

export function calculateAge(date: Date | any, decimals: number): string {
  return (Math.abs(Date.now() - date) / (1000 * 3600 * 24) / 365.2422).toFixed(decimals);
}

// export function getAge(birthDate: Date): { years: number; months: number; days: number } {
//   let currentDate = new Date();

//   const currentYear = currentDate.getFullYear();
//   const currentMonth = currentDate.getMonth();
//   const currentDay = currentDate.getDate();

//   const yearDob = birthDate.getFullYear();
//   const monthDob = birthDate.getMonth();
//   const dateDob = birthDate.getDate();

//   let yearAge = currentYear - yearDob;
//   let monthAge: number;
//   let dateAge: number;

//   if (currentMonth >= monthDob) {
//     monthAge = currentMonth - monthDob;
//   } else {
//     yearAge--;
//     monthAge = 12 + currentMonth - monthDob;
//   }

//   if (currentDay >= dateDob) {
//     dateAge = currentDay - dateDob;
//   } else {
//     monthAge--;
//     dateAge = 31 + currentDay - dateDob;

//     if (monthAge < 0) {
//       monthAge = 11;
//       yearAge--;
//     }
//   }

//   return {
//     years: yearAge,
//     months: monthAge,
//     days: dateAge,
//   };
// }

// export function getAgeMessage(years: number, months: number, days: number): string {
//   let yearsStr = years ? (years > 1 ? `${years} years` : `${years} year`) : '';
//   let monthsStr = months ? (months > 1 ? `${months} months` : `${months} month`) : '';
//   let daysStr = days ? (days > 1 ? `${days} days` : `${days} day`) : '';

//   let separatorComma = yearsStr && monthsStr ? ', ' : '';
//   let separatorAnd = (yearsStr || monthsStr) && daysStr ? ' and ' : '';

//   return yearsStr || monthsStr || daysStr
//     ? `${yearsStr}${separatorComma}${monthsStr}${separatorAnd}${daysStr} old`
//     : 'Could not calculate the age!';
// }

// export function getGeneralLicenseState(
//   licenseState: string | null,
//   licenseNumber: string | null,
//   licenseClass: string | null,
//   licenseExpiry: string | null
// ): string {
//   let result = '';

//   if (licenseState) {
//     result += `${licenseState.toUpperCase()}-`;
//   }

//   if (licenseNumber) {
//     result += `${licenseNumber} `;
//   }

//   if (licenseClass) {
//     result += `${licenseClass} `;
//   }

//   if (licenseExpiry) {
//     result += `${licenseExpiry} `;
//   }

//   return result.trim();
// }

// export function removeDelimiters(data: string | null) {
//   return !data ? '' : data.replace(/[\W]/g, '');
// }

export function getFullName(
  firstName: string,
  lastName: string,
  middleName: string,
  suffix: string,
  prefix: string
): string {
  const sign = prefix?.length || lastName?.length ? ',' : ' ';

  return prefix + ' ' + lastName + sign + ' ' + firstName + ' ' + middleName + ' ' + suffix;
}

// export function getFullNameFromModel(nameModel: NameModel | null | undefined): string {
//   const firstName = nameModel?.first || '';
//   const lastName = nameModel?.last || '';
//   const middleName = nameModel?.middle || '';
//   const suffix = nameModel?.suffix || '';
//   const prefix = nameModel?.prefix || '';

//   return getFullName(firstName, lastName, middleName, suffix, prefix);
// }

// export function formatTime(timeString: string) {
//   if (!timeString) {
//     return;
//   }

//   const [hourString, minute] = timeString.split(':');
//   const hour = +hourString % 24;
//   return (hour % 12 || 12) + ':' + minute + ' ' + (hour < 12 ? 'AM' : 'PM');
// }
